import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HappyPayBankAccountService } from '@features/user/services/happy-pay-bank-account.service';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { BankService } from '@shared/services/bank.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'fc-user-happy-pay-bank-account-dialog',
  templateUrl: './user-happy-pay-bank-account-dialog.component.html',
  styleUrls: ['./user-happy-pay-bank-account-dialog.component.css'],
})
export class UserHappyPayBankAccountDialogComponent
  implements OnInit, OnDestroy
{
  faSpinner = faSpinner;
  faTimes = faTimes;

  // subject
  private readonly destroy$ = new Subject<void>();

  bankAccountId?: number;
  bankAccount: any = null;
  bankAccountForm: FormGroup;
  bankDropdown: any = [];
  isSubmitted: boolean = false;
  loading: boolean = false;

  constructor(
    private hpBankAccService: HappyPayBankAccountService,
    private bankService: BankService,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private router: Router
  ) {
    this.bankAccountForm = new FormGroup({
      sequence: new FormControl(1),
      bank_id: new FormControl(0, Validators.required),
      account_no: new FormControl('', Validators.required),
      account_name: new FormControl('', Validators.required),
      branch: new FormControl('-'),
      is_active: new FormControl(true),
    });
    if (this.config.data) {
      if (this.config.data.bankAccount.id) {
        this.bankAccount = this.config.data.bankAccount;
      }
    }
  }

  ngOnInit(): void {
    this.bankService
      .getBanks()
      .pipe(takeUntil(this.destroy$))
      .subscribe((banks) => {
        if (banks) {
          for (let bank of banks) {
            this.bankDropdown.push({ label: bank.name, value: bank.id });
          }
          if (this.bankAccount) {
            console.log('hello');
            this.bankAccountId = this.bankAccount.id;
            this.setupForm(this.bankAccount);
          }
        }
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setupForm(data: any) {
    this.bankAccountForm.patchValue({
      sequence: data.sequence,
      bank_id: data.bank_id,
      account_no: data.account_no,
      account_name: data.account_name,
      branch: data.branch,
      is_active: data.is_active,
    });
  }

  onSubmit() {
    this.isSubmitted = true;
    this.loading = true;
    if (this.bankAccountId) {
      this.hpBankAccService
        .editHappyPayBankAccount(this.bankAccountId, this.bankAccountForm.value)
        .subscribe(
          (res) => {
            this.loading = false;
            this.hpBankAccService.setEditBankAccState(null);
            this.router.navigate(['/user/happy-pay/bank']);
            this.dismissModal();
          },
          (error) => {
            this.loading = false;
          }
        );
    } else {
      this.hpBankAccService
        .addHappyPayBankAccount(this.bankAccountForm.value)
        .subscribe(
          (res) => {
            this.loading = false;
            this.dismissModal(true);
          },
          (error) => {
            this.loading = false;
          }
        );
    }
  }

  dismissModal(isUpdated: boolean = false) {
    this.ref.close(isUpdated);
  }
}
